export const tabs = ['Main Content', 'Audit Trails'];
